import type { TOC } from '@ember/component/template-only';
import PageError from '../components/page-error.gts';

interface Signature {
  Args: {};
}

const MyItemsError: TOC<Signature> = <template>
  <PageError @title="Failed to load my items" @backRoute="index" />
</template>;

export default MyItemsError;
